'use client';

import { Eye } from 'lucide-react';
import { useTranslations } from 'next-intl';

export type UniqueVisitsIndicatorProps = {
  uniqueVisits?: number | null;
  variant?: 'overlay' | 'inline';
  className?: string;
};

export default function UniqueVisitsIndicator({
  uniqueVisits,
  variant = 'overlay',
  className = '',
}: UniqueVisitsIndicatorProps) {
  const t = useTranslations('common');

  const showVisits = uniqueVisits != null && Number.isFinite(uniqueVisits) && uniqueVisits >= 0;
  const iconSize = variant === 'overlay' ? 20 : 18;

  if (!showVisits) return null;

  const formatted =
    uniqueVisits >= 1000 ? `${(uniqueVisits / 1000).toFixed(1)}k` : String(uniqueVisits);

  const baseClasses =
    variant === 'overlay'
      ? 'absolute top-2 right-2 z-20 flex items-center gap-1.5 p-1.5 rounded-full bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm shadow-md'
      : 'inline-flex items-center gap-1';

  return (
    <div
      className={`${baseClasses} ${className}`}
      title={t('uniqueVisits')}
      aria-label={t('uniqueVisits')}
    >
      <Eye size={iconSize - 2} className="flex-shrink-0 text-slate-500 dark:text-slate-400" aria-hidden />
      <span className="text-slate-500 dark:text-slate-400 text-xs font-medium select-none">
        {formatted}
      </span>
    </div>
  );
}

